<template>
    <div v-bind:class="getClass" ref="root"></div>
</template>

<script>
import { mapGetters } from 'vuex';
import SVGInject from '@iconfu/svg-inject';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        renderIcon() {
            if (this.getSrc === null) {
                return;
            }
            if (this.$refs.root.querySelector('.svginject') !== null) {
                this.$refs.root.querySelector('.svginject').remove();
            }
            this.$refs.root.insertAdjacentHTML(
                'beforeend',
                '<img src="' +
                    this.getSrc +
                    '" alt="" class="svginject" width="100" height="100" />'
            );
            SVGInject(this.$refs.root.querySelector('.svginject'));
        }
    },
    computed: {
        ...mapGetters(['generateMediaUrl', 'getActiveIconstyle']),
        getSrc() {
            let args = {};
            if (this.path) {
                args['path'] = this.path;
            } else if (this.data && 'id' in this.data) {
                args['id'] = this.data.id;
                args['i'] = 1;
                args['v'] = this.getActiveIconstyle;
            }
            return this.generateMediaUrl(args);
        },
        getClass() {
            let str = 'icon';
            if (this.customClass) {
                str += ' ' + this.customClass;
            }
            return str;
        }
    },
    created() {},
    updated() {
        this.renderIcon();
    },
    mounted() {
        this.renderIcon();
    },
    props: {
        path: String,
        data: Object,
        customClass: String
    },
    watch: {
        /* if iconstyle is changed afterwards, change on the fly */
        getActiveIconstyle() {
            this.$nextTick().then(() => {
                this.renderIcon();
            });
        }
    }
};
</script>
